import { TICKETS_QUERY_CONTEXT_PREFIX } from './constants';

export function makeTicketsQueryContextKey(orderId: string) {
  return `${TICKETS_QUERY_CONTEXT_PREFIX}_${orderId}_tickets`;
}
